import { useCartStore, selectCartCount, selectCartTotal } from '@/stores/cart-store';

/**
 * Custom hook to get cart data (count and total)
 * Reusable across header components
 */
export function useCartData() {
  const cartCount = useCartStore(selectCartCount);
  const cartTotal = useCartStore(selectCartTotal);

  return {
    cartCount,
    cartTotal,
    formattedTotal: cartTotal.toFixed(2),
    hasItems: cartCount > 0,
  };
}
